import { Link } from 'react-router-dom';
import React from 'react';
import { Box, SimpleGrid, Heading } from '@chakra-ui/core';

export default function Commande(props) {
  return (
    <SimpleGrid columns={[2, 3, 5, 6]} spacing={5}>
      {props.cartegories &&
        props.cartegories.map(cat => {
          return (
            <Link key={cat.name} to={`/restaurants?filter=${cat.name}`}>
              <Box
                w="100%"
                h="200px"
                rounded="15px"
                bg="black"
                position="relative"
                cursor="pointer"
                shadow="md"
                bgRepeat="no-repeat"
                bgSize="cover"
                bgImage={`linear-gradient(0deg, black 0%, rgba(26,32,44,0) 50%),url(${process.env.REACT_APP_API}/storage/${cat.image})`}
              >
                {/* <Image
                  h="200px"
                  w="100%"
                  objectFit="cover"
                  opacity="0.7"
                  alt={cat.name}
                  rounded="15px"
                  src={`${process.env.REACT_APP_API}/storage/${cat.image}`}
                ></Image> */}

                <Heading
                  m="2"
                  color="white"
                  position="absolute"
                  bottom="2"
                  left="2"
                  mt="10px"
                  fontSize="18px"
                >
                  {cat.name}
                </Heading>
              </Box>
            </Link>
          );
        })}
    </SimpleGrid>
  );
}
